import React from 'react';
import PageTemplate from '../components/PageTemplate';

const StoresOverview = () => {
  return (
    <PageTemplate title="Stores Overview">
      {/* Add your content here */}
    </PageTemplate>
  );
};

export default StoresOverview;
